/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { IconContext } from "react-icons";
import { FaMobileAlt, FaEnvelope, FaLock, FaEye } from "react-icons/fa";
import { InputItem } from "antd-mobile";
import { injectIntl } from "react-intl";
import Color from "../utils/Color";

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  margin: 5px 0;
  border-radius: 25px;
  background: "white";
  border: 0.5px solid ${props => (props.color ? props.color : "lightgrey")};
  padding: 0.2em 1.8em;
  min-height: 1.4em;
`;

const StyledInput = {
  fontSize: "0.9em",
  marginLeft: "5px"
};

class TextInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
      passwordType: "password",
      isToggleOn: false
    };
    this.displayPassword = this.displayPassword.bind(this);
  }

  onFocus = () => {
    this.setState({
      editing: true
    });
  };

  clearFocus = () => {
    this.setState({
      editing: false
    });
  };

  getIcon = type => {
    switch (type) {
      case "mobile":
        return <FaMobileAlt />;
      case "email":
        return <FaEnvelope />;
      case "password":
        return <FaLock />;
    }
  };

  displayPassword = () => {
    this.setState(function(prevState) {
      return { isToggleOn: !prevState.isToggleOn };
    });
    if (this.state.isToggleOn === true) {
      this.setState({ passwordType: "password" });
    } else {
      this.setState({ passwordType: "txt" });
    }
  };

  getEye = type => {
    switch (type) {
      case "password":
        return (
          <FaEye
            style={this.state.isToggleOn ? { color: Color.Primary } : {}}
            onClick={this.displayPassword}
          />
        );
    }
  };

  getInput = type => {
    const {
      intl,
      error,
      onErrorClick,
      onChange,
      placeholder,
      defaultValue,
      disabled,
      value
    } = this.props;

    switch (type) {
      case "default":
        return (
          <InputItem
            value={value}
            defaultValue={defaultValue}
            ref={input => {
              this.defaultInput = input;
            }}
            error={error}
            onErrorClick={() => onErrorClick && onErrorClick()}
            onChange={txt => onChange && onChange(txt)}
            style={StyledInput}
            type={"text"}
            placeholder={
              placeholder
                ? placeholder
                : intl.formatMessage({
                    id: "component.input.text.placeholder",
                    defaultMessage: "Text",
                    description: "Placeholder on Text Input Type"
                  })
            }
            onFocus={() => this.onFocus()}
            onBlur={() => this.clearFocus()}
            disabled={disabled}
          />
        );
      case "mobile":
        return (
          <InputItem
            defaultValue={defaultValue}
            ref={input => {
              this.phoneInput = input;
            }}
            error={error}
            onErrorClick={() => onErrorClick && onErrorClick()}
            onChange={txt => onChange && onChange(txt)}
            style={StyledInput}
            type={"phone"}
            placeholder={
              placeholder
                ? placeholder
                : intl.formatMessage({
                    id: "component.input.phone.placeholder",
                    defaultMessage: "Mobile Number",
                    description: "Placeholder on Phone Input Type"
                  })
            }
            onFocus={() => this.onFocus()}
            onBlur={() => this.clearFocus()}
            disabled={disabled}
          />
        );
      case "email":
        return (
          <InputItem
            value={value}
            defaultValue={defaultValue}
            ref={input => {
              this.emailInput = input;
            }}
            error={error}
            onErrorClick={() => onErrorClick && onErrorClick()}
            onChange={txt => onChange && onChange(txt)}
            style={StyledInput}
            type={"email"}
            placeholder={
              placeholder
                ? placeholder
                : intl.formatMessage({
                    id: "component.input.email.placeholder",
                    defaultMessage: "Email",
                    description: "Placeholder on Email Input Type"
                  })
            }
            onFocus={() => this.onFocus()}
            onBlur={() => this.clearFocus()}
            disabled={disabled}
          />
        );
      case "password":
        return (
          <InputItem
            className={"password"}
            defaultValue={defaultValue}
            ref={input => {
              this.passInput = input;
            }}
            error={error}
            onErrorClick={() => onErrorClick && onErrorClick()}
            onChange={txt => onChange && onChange(txt)}
            style={StyledInput}
            type={this.state.passwordType}
            placeholder={
              placeholder
                ? placeholder
                : intl.formatMessage({
                    id: "component.input.password.placeholder",
                    defaultMessage: "Password",
                    description: "Placeholder on Password Input Type"
                  })
            }
            onFocus={() => this.onFocus()}
            onBlur={() => this.clearFocus()}
            disabled={disabled}
          />
        );
    }
  };

  getColor = () => {
    const { color, activeColor, error } = this.props;
    const { editing } = this.state;

    if (error) {
      return "red";
    }

    if (editing) {
      return activeColor ? activeColor : "grey";
    } else {
      return color ? color : "lightgrey";
    }
  };

  onClick = type => {
    switch (type) {
      case "default":
        this.defaultInput.focus();
        break;
      case "mobile":
        this.phoneInput.focus();
        break;
      case "email":
        this.emailInput.focus();
        break;
      case "password":
        this.passInput.focus();
        break;
    }
  };

  render() {
    const { type, style, className } = this.props;

    return (
      <StyledContainer
        className={className}
        color={this.getColor()}
        style={style}
        onClick={() => this.onClick(type)}
      >
        <IconContext.Provider value={{ color: this.getColor(), size: "1.2em" }}>
          {this.getIcon(type)}
          {this.getInput(type)}
          {this.getEye(type)}
        </IconContext.Provider>
      </StyledContainer>
    );
  }
}

TextInput.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  type: PropTypes.string,
  color: PropTypes.string,
  activeColor: PropTypes.string,
  placeholder: PropTypes.string,
  intl: PropTypes.object,
  style: PropTypes.object,
  error: PropTypes.bool,
  onErrorClick: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.string
};

export default injectIntl(TextInput);



// WEBPACK FOOTER //
// ./src/components/TextInput.js